<template>
    <div>
        <h3>ピックアップ</h3>
        <div>
            <p>
                本棚の上部に最大３作品をピックアップとして表示することができます。
                多作の作家さんは、複数のジャンルの中でお勧めしたい作品を掲載することで、
                読者にアピールすることができます。
            </p>
            <img src="/img/help/novel/15.png" alt="ピックアップ" class="img-thumbnail mb-3">
            <h4>ピックアップを追加する</h4>
            <p>
                小説一覧画面の上部に「ピックアップ追加」ボタンがあるので、
                そこから追加する小説を選択してください。
            </p>
            <h4>ピックアップを削除する</h4>
            <p>
                追加したピックアップを削除する場合は、「削除」ボタンをクリックしてください。
                ピックアップだけが削除され、小説本文は削除されません。
            </p>
        </div>
    </div>
</template>

<style src="../help.scss" scoped lang="scss"></style>

<script>
export default {
    created() {
        this.useHead({
            title: "ピックアップ | 貸し本棚ヘルプ",
            link: [
                {
                    rel: "canonical",
                    href: location.origin + location.pathname,
                    id: "canonical"
                }
            ]
        });
    }
}
</script>